@if (showAlarmBar$ | async) {
  <gbc-banner type="alarm" class="mt-8">
    <img src="./assets/svgs/alarm.svg" />
    <div>{{ 'mixit-installation-page.alarm' | translate }}</div>
  </gbc-banner>
}

@if (showWarningBar$ | async) {
  <gbc-banner type="warning" class="mt-8">
    <img src="./assets/svgs/warning.svg" />
    <div>{{ 'mixit-installation-page.warning' | translate }}</div>
  </gbc-banner>
}

@if ((installationCommissionState$ | async) === 'Error') {
  <gbc-banner type="warning" class="mt-8">
    <img src="./assets/svgs/warning.svg" />
    <div [innerHtml]="'mixit-device-states.error-for-device-to-connect' | translate"></div>
  </gbc-banner>
}

@if (isLessThanHalfHourSinceClaim$ | async) {
  <gbc-banner type="info" class="mt-8">
    <div [innerHtml]="'mixit-device-states.waiting-for-device-to-connect' | translate"></div>
  </gbc-banner>
}

@if (installation$ | async; as installation) {
  @if (showUpgradeBar$ | async) {
    <gbc-banner type="info" class="mt-8">
      <img src="./assets/svgs/list-commissioning.svg" />
      <div>{{ 'trial-upgrade-banner.text' | translate: { trialPeriod: MixitTrialPeriod } }}</div>
      <button
        gbc-button
        [routerLink]="'/upgrade/trial/'"
        [queryParams]="{ installationId: installation.id }"
        angulartics2On="click"
        angularticsAction="upgradeTrialClicked"
        angularticsCategory="mixitFreemium"
        >
        {{ 'trial-upgrade-banner.button' | translate }}
      </button>
    </gbc-banner>
  }
}

<app-schematics-tile
  [applicationId]="(application$ | async)?.id"
  [installationId]="(installation$ | async)?.id"
  [dataPoints$]="dataPoints$"
  [disableAlarms]="true"
  height="500"
  [commissionState]="installationCommissionState$ | async"
  [showShadow]="false"
  >
</app-schematics-tile>

<div class="tile-grid mb-8">
  <gbc-tile [title]="productType$ | async">
    <img
      gbc-tile-left
      (click)="showProductInfo()"
      class="info-img"
      [alt]="'mixit-installation-page.product-information' | translate"
      src="./assets/svgs/info-circle_outline.svg"
      />

      <div class="tile-content">
        <div class="tile-row">
          <div class="tile-row-name">{{ 'mixit-installation-page.operation-mode' | translate }}</div>
          <div class="tile-row-value">{{ operationMode$ | async }}</div>
        </div>
      </div>
    </gbc-tile>

    <gbc-tile [title]="'mixit-installation-page.temperature' | translate">
      <div class="tile-content">
        <div class="tile-row">
          <div class="tile-row-name">{{ 'mixit-installation-page.setpoint' | translate }}</div>
          @if ((showLocalSetpoint$ | async) === false) {
            <div class="tile-row-value">
              {{ setpoint$ | async | formatDataPoint }}
            </div>
          }
          @if (showLocalSetpoint$ | async) {
            <div class="tile-row-value">
              {{ localSetpoint$ | async | formatDataPoint }}
            </div>
          }
        </div>

        <div class="tile-row">
          <div class="tile-row-name">{{ 'mixit-installation-page.setpoint-source' | translate }}</div>
          @if (setpointSource$ | async; as setpointSource) {
            <div class="tile-row-value">
              {{ 'mixit-setpoint-source.' + (setpointSource | formatDataPoint) | translate }}
            </div>
          }
        </div>
      </div>
    </gbc-tile>

    @if (showPumpTile$ | async) {
      <gbc-tile [title]="pumpType$ | async">
        <img
          gbc-tile-left
          (click)="showPumpInfo()"
          class="info-img"
          src="./assets/svgs/info-circle_outline.svg"
          angulartics2On="click"
          angularticsAction="mixitProductInfoIconClicked"
          angularticsCategory="mixitSchematicClicked"
          data-test-id="pump-tile-info-icon"
          />
          <div class="tile-content">
            <div class="tile-row">
              <div class="tile-row-name">{{ 'mixit-installation-page.control-mode' | translate }}</div>
              <div class="tile-row-value">{{ controlMode$ | async }}</div>
            </div>
          </div>
        </gbc-tile>
      }

      @if (isDynamic$ | async) {
        <app-energy-monitoring-tile
          [installation$]="installation$"
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application$]="application$"
        ></app-energy-monitoring-tile>
      }
    </div>

    @if (showWeatherCurve$ | async) {
      <gbc-tile [title]="'mixit-installation-page.heat-curve-chart-title' | translate">
        <app-weather-curve-chart [data$]="weatherCurve$" [outdoorTemp$]="outdoorTemp$"></app-weather-curve-chart>
      </gbc-tile>
    }
